const A = 36, I = 2, o = 320, t = 280, _ = 334;
export {
  I as DAY_MARGIN,
  A as DAY_SIZE,
  o as DIALOG_WIDTH,
  t as MAX_CALENDAR_HEIGHT,
  _ as VIEW_HEIGHT
};
//# sourceMappingURL=dimensions.mjs.map
